import {createSlice} from '@reduxjs/toolkit';

// Which company the current session is operating on.
// - Platform super-admin: drives X-Company-Id (see configs/api.js) and the platform picker gate.
// - Multi-company members: UX selection synced with JWT company_id after switch-company.
// - Single-company members: auto-set from user.company_id; API scoping remains JWT-only.
const STORAGE_KEY = 'selectedCompany';

const loadPersisted = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {selectedCompanyId: null, selectedCompanyName: ''};
    const parsed = JSON.parse(raw);
    return {
      selectedCompanyId: parsed.selectedCompanyId || null,
      selectedCompanyName: parsed.selectedCompanyName || '',
    };
  } catch (e) {
    return {selectedCompanyId: null, selectedCompanyName: ''};
  }
};

const persist = (state) => {
  try {
    if (state.selectedCompanyId) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        selectedCompanyId: state.selectedCompanyId,
        selectedCompanyName: state.selectedCompanyName,
      }));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    // ignore storage failures (private mode, etc.)
  }
};

const initialState = loadPersisted();

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setSelectedCompany(state, action) {
      state.selectedCompanyId = action.payload?.id || null;
      state.selectedCompanyName = action.payload?.name || '';
      persist(state);
    },
    clearSelectedCompany(state) {
      state.selectedCompanyId = null;
      state.selectedCompanyName = '';
      persist(state);
    },
  },
});

// Selectors
export const getSelectedCompanyId = (state) => state.tenant.selectedCompanyId;
export const getSelectedCompanyName = (state) => state.tenant.selectedCompanyName;

// Actions
export const {setSelectedCompany, clearSelectedCompany} = tenantSlice.actions;

export default tenantSlice.reducer;
